import { Directive, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';

/**
 * Generated class for the AutoresizeDirective directive.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 * for more info on Angular Directives.
 */
@Directive({
  selector: 'textarea[autoresize]' // Attribute selector
})
export class AutoresizeDirective {
  @Output() updatedHeight = new EventEmitter();

  @HostListener("input", ["$event.target"])
	onInput(textArea: HTMLTextAreaElement): void {
		this.adjust();
	}

  @HostListener("focus", ["$event.target"])
	onFocus(textArea: HTMLTextAreaElement): void {
    setTimeout( () => {
      console.log("onInput");
      this.adjust();
    });
	}

	constructor(public element: ElementRef) {
	}
	ngOnInit(): void {
    var me = this;
    setTimeout(function(){
		  me.adjust();
    }, 100);
	}
	adjust(): void {
		let ta = this.element.nativeElement;
    if (ta != null) {
      ta.style.overflow = "hidden";
      ta.style.height = "auto";
      ta.style.height = ta.scrollHeight + "px";
      this.updatedHeight.emit(this);
    }
  }

  adjustHeight(): void {
    console.log("adjustHeight");
		let ta = this.element.nativeElement;
    if (ta != null) {
      ta.style.overflow = "hidden";
      ta.style.height = "auto";
      ta.style.height = ta.scrollHeight + "px";
      this.onFocus(ta);
    }
	}

}



// WEBPACK FOOTER //
// ./src/directives/autoresize/autoresize.ts